define('glu/grid/savedViews/components/savedViewsCollection',['require','../../../collection','./savedViewsModel','../../../util','../../../http','../../../store'],function(require) {
    'use strict';

    var Collection = require('../../../collection'),
        SavedViewsModel = require('./savedViewsModel'),
        util = require('../../../util'),
        http = require('../../../http'),
        store = require('../../../store');

    return Collection.extend({
        model: SavedViewsModel,

        initialize: function(models, options) {
            options = options || {};

            this.listenTo(this, {
                'add remove': this.save,
                'change:default': this.enforceSingleDefault
            });

            this.gridName = options.gridName || 'gridDefaultName';
            this.stateModel = options.stateModel;
            this.storage = store.getStorage(options.storage || 'localStorage');

            this.fetch({
                reset: true
            });
        },


        save: function() {
            var options = {
                error: util.noop,
                success: function() {
                    this.trigger('sync', this, this.toJSON());
                }.bind(this)
            };

            return this.sync('create', this, options);
        },

        enforceSingleDefault: function(model, value) {
            if (!value) {
                return; // if the model was changed to not default, do nothing
            }

            this.each(function(otherModel) {
                if (otherModel !== model) {
                    otherModel.set({
                        'default': false
                    });
                }
            }, this);

            this.save(); // save when all models are done changing
        },

        getDefaultModel: function() {
            var defaultModel = this.findWhere({
                'default': true
            });

            return defaultModel || this.stateModel;
        },

        // override this method to add your own server-side persistence
        // note that the current implementation does not return a jqXHR object
        sync: function(method, collection, options) {

            if (!this.storage) {
                options.error();
                return;
            }

            if (method === 'read') {
                var data = this.storage.get(this.gridName) || [];
                options.success(data);
            }

            if (method === 'create') {
                this.storage.set(this.gridName, this.toJSON());
                options.success();
            }
        }
    });
});

